import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Typography, Result } from 'antd'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.bubble.css'
import { Helmet } from 'react-helmet-async'
import pagesService from '../../services/pagesService'
import { Page } from '../../services/models'

type Props = {}

const StaticPageContent: React.FC<Props> = () => {
  const { url } = useParams<{ url: string }>()

  const [page, setPage] = useState<Page | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    if (!url) return
    setLoading(true)
    setError(false)
    pagesService.getPublic(url).then((data) => {
      setPage(data.page)
    }).catch(() => {
      setError(true)
    }).finally(() => {
      setLoading(false)
    })
  }, [url])

  if (loading) return null

  if (error || !page) {
    return (
            <div>
                <Result
                    status="404"
                    title="404"
                    subTitle="Страница не найдена"
                />
            </div>
    )
  }

  return (
        <div>
            <Helmet><title>Prisma — {page.title}</title></Helmet>
            <Typography.Title level={2}>{page.title}</Typography.Title>
            <ReactQuill
                value={page.content}
                readOnly={true}
                theme="bubble"
            />
        </div>
  )
}

export default StaticPageContent
